export interface Movie {
  id: string;
  title: string;
  englishTitle: string;
  year: number;
  category: string;
  subCategory: string;
  rating: number;
  duration: string;
  region: string;
  director: string;
  cast: string[];
  description: string;
  content: string;
  poster: string;
  backdrop: string;
  releaseDate: string;
  isNew: boolean;
  isHot: boolean;
  isFeatured: boolean;
  tags: string[];
}

export const categories = [
  { key: 'all', name: '全部', icon: 'ri-movie-line' },
  { key: 'action', name: '动作片', icon: 'ri-fire-line' },
  { key: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line' },
  { key: 'romance', name: '爱情', icon: 'ri-heart-line' },
  { key: 'scifi', name: '科幻', icon: 'ri-rocket-line' },
  { key: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
  { key: 'animation', name: '动画', icon: 'ri-palette-line' },
  { key: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { key: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { key: 'documentary', name: '纪录片', icon: 'ri-camera-line' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '暗夜追踪',
    englishTitle: 'Night Pursuit',
    year: 2026,
    category: 'action',
    subCategory: '动作片',
    rating: 8.5,
    duration: '128分钟',
    region: '中国大陆',
    director: '张克帆',
    cast: ['刘浩然', '张钧宁', '王大陆', '陈坤'],
    description: '一名退役特种兵为寻找失踪的女儿，潜入黑暗的地下犯罪网络，展开一场惊心动魄的追踪之旅。高燃打斗场面与悬疑剧情完美融合，呈现国产动作片新高度。',
    content: '<p>《暗夜追踪》是一部集动作、悬疑于一体的国产大片。影片讲述退役特种兵林峰（刘浩然饰）的女儿突然失踪，警方调查无果后，他决定孤身一人深入城市的黑暗角落寻找真相。</p><p>在追踪过程中，林峰遇到了神秘女子柳青（张钧宁饰），两人联手揭开了隐藏在光鲜城市外表下的巨大犯罪网络。影片以凌厉的动作设计和紧凑的叙事节奏著称，尤其是地下车库追逐战和高楼跑酷两场戏，堪称近年来国产动作片的巅峰之作。</p><p>导演张克帆凭借此片获得第38届中国电影金鸡奖最佳动作设计提名，影片票房突破15亿。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20with%20soldier%20in%20dark%20city%20alley%20at%20night%2C%20rain%2C%20neon%20lights%2C%20intense%20expression%2C%20cinematic%20lighting%2C%20warm%20red%20and%20black%20tones%2C%20movie%20poster%20style%20with%20Chinese%20text%20space&width=600&height=800&seq=movie-action-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=dark%20city%20alley%20at%20night%20with%20neon%20lights%20and%20rain%2C%20solitary%20figure%20walking%2C%20cinematic%20wide%20shot%2C%20atmospheric%2C%20warm%20dark%20tones%2C%20film%20noir%20aesthetic&width=1600&height=900&seq=movie-action-bd-01&orientation=landscape',
    releaseDate: '2026-07-15',
    isNew: true,
    isHot: true,
    isFeatured: true,
    tags: ['高燃', '悬疑', '动作大片', '国产'],
  },
  {
    id: 'movie-2',
    title: '欢乐大厨',
    englishTitle: 'Happy Chef',
    year: 2026,
    category: 'comedy',
    subCategory: '喜剧',
    rating: 7.9,
    duration: '105分钟',
    region: '中国大陆',
    director: '宁浩',
    cast: ['沈腾', '马丽', '艾伦', '常远'],
    description: '一位从未下过厨的富二代被迫接手家族餐厅，闹出无数笑话的同时，也逐渐找到了烹饪的真谛和人生的方向。',
    content: '<p>《欢乐大厨》是由宁浩执导，沈腾、马丽领衔主演的喜剧电影。影片讲述了富二代郝笑（沈腾饰）因家族企业危机，被迫接手一家濒临倒闭的老牌餐厅的故事。</p><p>从未进过厨房的郝笑闹出了无数笑话：把盐当成糖、把醋当成酱油、把抹布当成了牛排……但在老厨师长（马丽饰）的帮助下，他逐渐领悟了烹饪的艺术和经营的真谛。</p><p>影片笑点密集，温情脉脉，是2026年暑期档最令人捧腹又感动的合家欢电影。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20chef%20in%20kitchen%20making%20funny%20face%2C%20bright%20warm%20colors%2C%20food%20flying%20in%20air%2C%20chaotic%20kitchen%20scene%2C%20playful%20vibe%2C%20cinematic%20poster%20style&width=600&height=800&seq=movie-comedy-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=bright%20colorful%20professional%20kitchen%20with%20steam%20and%20food%2C%20warm%20lighting%2C%20chaotic%20but%20happy%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=movie-comedy-bd-01&orientation=landscape',
    releaseDate: '2026-07-22',
    isNew: true,
    isHot: true,
    isFeatured: true,
    tags: ['搞笑', '美食', '合家欢', '国产喜剧'],
  },
  {
    id: 'movie-3',
    title: '星河恋曲',
    englishTitle: 'Starry Love Story',
    year: 2026,
    category: 'romance',
    subCategory: '爱情',
    rating: 8.2,
    duration: '118分钟',
    region: '中国大陆',
    director: '陈思诚',
    cast: ['周冬雨', '井柏然', '倪妮', '李现'],
    description: '天文学家和旅行作家在青海星空下邂逅，一段跨越时间和距离的浪漫爱情故事，唯美如画。',
    content: '<p>《星河恋曲》讲述天文学家苏星（井柏然饰）在青海天文观测站偶遇旅行作家林月（周冬雨饰），两人在璀璨星空下展开了一段唯美的爱情故事。</p><p>影片横跨青海、西藏、云南三地取景，每一帧都美如壁纸。导演陈思诚以细腻的笔触描绘了现代都市人的情感困境和对纯粹爱情的向往。</p><p>特别值得一提的是影片的摄影和音乐，荣获第38届金鸡奖最佳摄影和最佳原创音乐两项大奖。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20movie%20poster%20with%20couple%20under%20starry%20night%20sky%20in%20Qinghai%2C%20silhouettes%2C%20milky%20way%2C%20dreamy%20atmosphere%2C%20soft%20warm%20glow%2C%20cinematic%20romantic%20style&width=600&height=800&seq=movie-romance-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=starry%20night%20sky%20with%20milky%20way%20over%20grassland%2C%20silhouette%20of%20two%20people%20standing%2C%20dreamy%20blue%20and%20purple%20tones%2C%20romantic%20cinematic%20wide%20shot&width=1600&height=900&seq=movie-romance-bd-01&orientation=landscape',
    releaseDate: '2026-06-14',
    isNew: false,
    isHot: true,
    isFeatured: true,
    tags: ['浪漫', '唯美', '文艺', '国产爱情'],
  },
  {
    id: 'movie-4',
    title: '星际纪元：重生',
    englishTitle: 'Star Era: Rebirth',
    year: 2026,
    category: 'scifi',
    subCategory: '科幻',
    rating: 8.8,
    duration: '145分钟',
    region: '中国大陆',
    director: '郭帆',
    cast: ['吴京', '赵今麦', '沙溢', '李雪健'],
    description: '人类文明在末日浩劫后重建家园，面对未知宇宙力量的威胁，一支精英小队踏上了拯救人类的星际远征。',
    content: '<p>《星际纪元：重生》是郭帆导演暌违三年后的科幻巨制。故事设定在近未来，地球遭遇太阳系异常能量冲击后陷入冰河期，人类被迫建造地下城市苟延残喘。</p><p>当科学家发现危机源头来自半人马座阿尔法星的神秘信号时，由陈远（吴京饰）率领的星际远征队乘坐人类最先进的曲率飞船"希望号"踏上征程。</p><p>影片视觉特效由顶级团队打造，投资超8亿人民币，是中国科幻电影的里程碑之作，上映首周票房突破20亿。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20spaceship%20approaching%20alien%20planet%2C%20epic%20scale%2C%20astronaut%20in%20foreground%2C%20cosmic%20nebula%20colors%2C%20cinematic%20blockbuster%20style&width=600&height=800&seq=movie-scifi-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=epic%20spaceship%20flying%20through%20colorful%20nebula%20in%20deep%20space%2C%20stars%2C%20cosmic%20dust%2C%20cinematic%20sci-fi%20wide%20shot%2C%20grand%20scale&width=1600&height=900&seq=movie-scifi-bd-01&orientation=landscape',
    releaseDate: '2026-07-01',
    isNew: true,
    isHot: true,
    isFeatured: true,
    tags: ['科幻巨制', '硬科幻', '史诗', '国产'],
  },
  {
    id: 'movie-5',
    title: '回魂夜',
    englishTitle: 'Night of the Returning Soul',
    year: 2026,
    category: 'horror',
    subCategory: '恐怖',
    rating: 7.2,
    duration: '95分钟',
    region: '中国香港',
    director: '麦浚龙',
    cast: ['林家栋', '邓丽欣', '罗兰', '古天乐'],
    description: '一栋老旧公寓里接连发生离奇死亡事件，一位阴阳眼少女必须揭开三十年前的灭门惨案真相。',
    content: '<p>《回魂夜》是麦浚龙继《僵尸》之后的又一恐怖力作。故事发生在香港一栋已有60年历史的唐楼中，租客们接二连三地离奇死亡，死状恐怖。</p><p>拥有阴阳眼的少女阿欣（邓丽欣饰）搬入这栋公寓后，开始看到一些不干净的东西。在退休警探陈伯（林家栋饰）的帮助下，她逐渐揭开三十年前一桩灭门惨案的真相。</p><p>影片融合了中国传统民俗元素和现代恐怖美学，被誉为近年来最吓人的华语恐怖片。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20movie%20poster%20with%20old%20apartment%20building%2C%20ghostly%20figure%20in%20window%2C%20dark%20atmosphere%2C%20red%20and%20black%20tones%2C%20Hong%20Kong%20style%2C%20eerie%20cinematic%20poster&width=600&height=800&seq=movie-horror-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=old%20Hong%20Kong%20apartment%20building%20at%20night%20with%20dim%20lighting%2C%20fog%2C%20eerie%20atmosphere%2C%20dark%20corridor%2C%20cinematic%20horror%20wide%20shot&width=1600&height=900&seq=movie-horror-bd-01&orientation=landscape',
    releaseDate: '2026-08-07',
    isNew: true,
    isHot: false,
    isFeatured: false,
    tags: ['恐怖', '悬疑', '港产', '灵异'],
  },
  {
    id: 'movie-6',
    title: '熊猫奇遇记',
    englishTitle: 'Panda Adventure',
    year: 2026,
    category: 'animation',
    subCategory: '动画',
    rating: 8.0,
    duration: '92分钟',
    region: '中国大陆',
    director: '饺子',
    cast: ['杨紫', '刘宪华', '周深', '郭麒麟'],
    description: '一只活泼可爱的大熊猫宝宝离开竹林家园，踏上了一段充满欢笑与感动的奇妙冒险之旅。',
    content: '<p>《熊猫奇遇记》是由饺子导演（《哪吒》导演）倾力打造的国产动画新作。影片讲述大熊猫宝宝圆圆在四川竹林中快乐生活，一天它意外跌入一个神秘山洞，进入了一个奇妙的平行世界。</p><p>在这里，圆圆遇到了会说话的猴子、会飞的鱼和会唱歌的花朵，还结识了一群有趣的动物朋友。它们一起穿越雪山、沙漠和海洋，寻找回家的路。</p><p>影片画风精致细腻，融入了大量中国水墨画元素，音乐由周深演唱主题曲，上映后口碑炸裂。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20cute%20panda%20in%20bamboo%20forest%2C%20colorful%20magical%20world%2C%20Chinese%20ink%20painting%20style%2C%20warm%20vibrant%20colors%2C%20animated%20film%20poster&width=600&height=800&seq=movie-anim-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20bamboo%20forest%20with%20sunlight%20rays%2C%20magical%20atmosphere%2C%20ink%20painting%20style%20landscape%2C%20warm%20golden%20light%2C%20animated%20movie%20style&width=1600&height=900&seq=movie-anim-bd-01&orientation=landscape',
    releaseDate: '2026-07-10',
    isNew: true,
    isHot: true,
    isFeatured: false,
    tags: ['动画', '冒险', '合家欢', '国产动漫'],
  },
  {
    id: 'movie-7',
    title: '迷雾追踪',
    englishTitle: 'Fog Tracking',
    year: 2026,
    category: 'thriller',
    subCategory: '悬疑',
    rating: 8.3,
    duration: '112分钟',
    region: '中国大陆',
    director: '曹保平',
    cast: ['黄渤', '段奕宏', '宋佳', '张译'],
    description: '连环凶杀案背后的惊人秘密，两位刑警跨越十年的追凶之旅，真相远比想象中更令人不寒而栗。',
    content: '<p>《迷雾追踪》由曹保平导演，黄渤、段奕宏主演的悬疑犯罪片。故事以一起发生在雾都重庆的连环凶杀案为起点，年轻刑警李牧（段奕宏饰）接手此案。</p><p>随着调查深入，他发现所有线索都指向十年前一桩已经结案的旧案。退休老刑警老周（黄渤饰）被重新卷入这场噩梦，两个时代的警察联手，穿越十年迷雾追查真凶。</p><p>影片节奏紧张，反转不断，结局出人意料，被誉为年度最佳悬疑片。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20thriller%20movie%20poster%20with%20detective%20in%20foggy%20city%2C%20mysterious%20silhouette%2C%20dark%20moody%20atmosphere%2C%20film%20noir%20style%2C%20dramatic%20lighting&width=600&height=800&seq=movie-thrill-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=foggy%20city%20street%20at%20night%20with%20wet%20pavement%2C%20street%20lamps%2C%20mysterious%20atmosphere%2C%20Chongqing%20style%2C%20cinematic%20noir%20wide%20shot&width=1600&height=900&seq=movie-thrill-bd-01&orientation=landscape',
    releaseDate: '2026-06-20',
    isNew: false,
    isHot: true,
    isFeatured: false,
    tags: ['悬疑', '犯罪', '反转', '国产'],
  },
  {
    id: 'movie-8',
    title: '山那边',
    englishTitle: 'Beyond the Mountain',
    year: 2026,
    category: 'drama',
    subCategory: '剧情',
    rating: 9.0,
    duration: '135分钟',
    region: '中国大陆',
    director: '文牧野',
    cast: ['易烊千玺', '惠英红', '张颂文', '秦海璐'],
    description: '大山里的留守儿童与年轻支教老师之间的感人故事，在贫瘠的土地上播种希望的种子。',
    content: '<p>《山那边》是文牧野导演继《我不是药神》后又一部现实主义力作。影片聚焦云南大山深处的留守儿童群体。</p><p>刚从师范毕业的年轻教师小陈（易烊千玺饰）被分配到大山深处的一所只有12个学生的乡村小学支教。面对恶劣的条件和孩子们孤独的心灵，他用自己的方式给予他们知识和温暖。</p><p>影片真实感人，没有任何刻意的煽情，却让无数观众潸然泪下。惠英红饰演的校长角色更是入木三分，获评年度最佳表演。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%20with%20teacher%20and%20children%20in%20mountain%20village%2C%20warm%20sunlight%2C%20rustic%20setting%2C%20emotional%20atmosphere%2C%20realistic%20style%2C%20touching%20poster&width=600&height=800&seq=movie-drama-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Chinese%20mountain%20village%20landscape%20with%20terraced%20fields%2C%20misty%20mountains%2C%20warm%20sunset%20light%2C%20rustic%20school%20building%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=movie-drama-bd-01&orientation=landscape',
    releaseDate: '2026-05-18',
    isNew: false,
    isHot: false,
    isFeatured: true,
    tags: ['剧情', '感人', '现实主义', '社会'],
  },
  {
    id: 'movie-9',
    title: '极限营救2',
    englishTitle: 'Extreme Rescue 2',
    year: 2026,
    category: 'action',
    subCategory: '动作片',
    rating: 8.1,
    duration: '122分钟',
    region: '中国香港',
    director: '林超贤',
    cast: ['彭于晏', '谢霆锋', '倪妮', '张家辉'],
    description: '国际救援队在东南亚遭遇前所未有的危机，高规格动作场面与灾难元素完美结合。',
    content: '<p>《极限营救2》是林超贤导演的动作系列第二部，故事升级到国际舞台。国际救援队接到紧急任务，前往遭遇超级台风的东南亚某国执行救援。</p><p>彭于晏饰演的队长方浩带领团队在飓风、海啸和余震中与时间赛跑，同时还要应对当地的武装势力威胁。谢霆锋饰演的神秘雇佣兵的加入让故事更加复杂。</p><p>影片实景拍摄+顶级特效，灾难场面震撼人心，动作设计更是达到了华语动作片的新标杆。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20with%20rescue%20team%20in%20disaster%20zone%2C%20explosion%2C%20helicopter%2C%20intense%20action%2C%20warm%20orange%20and%20dark%20tones%2C%20blockbuster%20style&width=600&height=800&seq=movie-action-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=disaster%20zone%20with%20destroyed%20buildings%20and%20flood%2C%20rescue%20helicopter%2C%20dramatic%20sky%2C%20intense%20action%20cinematic%20wide%20shot&width=1600&height=900&seq=movie-action-bd-02&orientation=landscape',
    releaseDate: '2026-08-15',
    isNew: true,
    isHot: false,
    isFeatured: false,
    tags: ['动作', '灾难', '救援', '大片'],
  },
  {
    id: 'movie-10',
    title: '笑傲厨房',
    englishTitle: 'Laughing in the Kitchen',
    year: 2026,
    category: 'comedy',
    subCategory: '喜剧',
    rating: 7.5,
    duration: '98分钟',
    region: '中国大陆',
    director: '闫非',
    cast: ['贾玲', '张小斐', '魏翔', '大鹏'],
    description: '三位不会做饭的闺蜜意外报名厨艺大赛，在笑料百出的比赛过程中发现了友情和生活的真谛。',
    content: '<p>《笑傲厨房》延续了贾玲、张小斐的喜剧黄金搭档组合。影片讲述了三个多年好友为了赢取巨额奖金，阴差阳错地报名参加全国厨艺大赛的故事。</p><p>三个完全不会做饭的人如何在高手如云的赛场上存活下来？她们用各种奇葩的烹饪方法和令人捧腹的创意菜品一路过关斩将，笑料不断。</p><p>影片轻松愉快，笑中带泪，是闺蜜聚会的绝佳观影选择。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20three%20women%20in%20messy%20kitchen%2C%20laughing%2C%20cooking%20disaster%2C%20bright%20colors%2C%20fun%20atmosphere%2C%20cinematic%20poster&width=600&height=800&seq=movie-comedy-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=messy%20colorful%20kitchen%20with%20food%20splatters%2C%20bright%20lighting%2C%20fun%20chaotic%20scene%2C%20cooking%20competition%20set%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=movie-comedy-bd-02&orientation=landscape',
    releaseDate: '2026-07-28',
    isNew: false,
    isHot: true,
    isFeatured: false,
    tags: ['喜剧', '闺蜜', '美食', '轻松'],
  },
  {
    id: 'movie-11',
    title: '深海密码',
    englishTitle: 'Deep Sea Code',
    year: 2026,
    category: 'scifi',
    subCategory: '科幻',
    rating: 8.4,
    duration: '130分钟',
    region: '中国大陆',
    director: '陆川',
    cast: ['彭于晏', '汤唯', '王阳', '高叶'],
    description: '深海科考队在马里亚纳海沟发现神秘文明遗迹，一场关乎人类命运的深海冒险就此展开。',
    content: '<p>《深海密码》是陆川导演历时五年打造的科幻冒险巨制。故事讲述了由海洋学家沈岚（汤唯饰）率领的深海科考队在马里亚纳海沟11000米深处，发现了令人震惊的史前文明遗迹。</p><p>随着调查深入，他们发现这个远古文明掌握的能量技术可能改写人类科技史，但同时也不慎激活了沉睡万年的古老守护系统。</p><p>影片水下摄影技术达到国际一流水准，深海场景的视觉呈现令人叹为观止。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20deep%20sea%20submarine%20and%20ancient%20ruins%2C%20bioluminescent%20glow%2C%20mysterious%20atmosphere%2C%20dark%20blue%20tones%2C%20cinematic%20poster&width=600&height=800&seq=movie-scifi-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=deep%20ocean%20floor%20with%20ancient%20ruins%2C%20bioluminescent%20creatures%2C%20submarine%20lights%2C%20mysterious%20blue%20glow%2C%20cinematic%20underwater%20wide%20shot&width=1600&height=900&seq=movie-scifi-bd-02&orientation=landscape',
    releaseDate: '2026-08-01',
    isNew: true,
    isHot: false,
    isFeatured: false,
    tags: ['科幻', '深海', '冒险', '国产'],
  },
  {
    id: 'movie-12',
    title: '夏日恋歌',
    englishTitle: 'Summer Love Song',
    year: 2026,
    category: 'romance',
    subCategory: '爱情',
    rating: 7.8,
    duration: '108分钟',
    region: '中国台湾',
    director: '陈玉珊',
    cast: ['许光汉', '王净', '柯佳嬿', '林柏宏'],
    description: '台北的夏天，一段不经意的邂逅，两颗孤独的心在音乐中找到了彼此，谱写最动人的夏日恋曲。',
    content: '<p>《夏日恋歌》是一部清新治愈的台湾爱情电影。钢琴调音师阿杰（许光汉饰）在一次工作途中遇到了街头艺人小雨（王净饰），被她即兴弹唱的一首歌深深打动。</p><p>两人因为对音乐的共同热爱越走越近，在台北的大街小巷留下了无数美好回忆。然而小雨即将前往维也纳深造，面对分离，他们必须做出选择。</p><p>影片配乐由知名音乐人陈建骐操刀，每一首插曲都动人心弦，画面唯美如诗。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Taiwanese%20romance%20movie%20poster%20with%20couple%20on%20scooter%20in%20Taipei%20street%2C%20summer%20vibe%2C%20sunset%20light%2C%20warm%20golden%20tones%2C%20youthful%20cinematic%20style&width=600&height=800&seq=movie-romance-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Taipei%20city%20street%20at%20sunset%2C%20warm%20golden%20light%2C%20scooter%2C%20summer%20atmosphere%2C%20romantic%20cinematic%20wide%20shot&width=1600&height=900&seq=movie-romance-bd-02&orientation=landscape',
    releaseDate: '2026-07-20',
    isNew: true,
    isHot: false,
    isFeatured: false,
    tags: ['爱情', '音乐', '台湾', '清新'],
  },
  {
    id: 'movie-13',
    title: '最后的证人',
    englishTitle: 'The Last Witness',
    year: 2026,
    category: 'thriller',
    subCategory: '悬疑',
    rating: 8.6,
    duration: '118分钟',
    region: '中国大陆',
    director: '忻钰坤',
    cast: ['于和伟', '袁泉', '雷佳音', '谭卓'],
    description: '一名律师在法庭上为其委托人进行无罪辩护，却发现真相远比案件本身更加复杂和危险。',
    content: '<p>《最后的证人》由忻钰坤导演，于和伟、袁泉主演的法律悬疑片。著名刑辩律师沈仲平（于和伟饰）接到了一个看似普通的谋杀案。</p><p>但随着调查深入，他发现案件背后牵扯到一个庞大的利益集团，证人接连遇害，连他自己和家人的生命也受到了威胁。在正义与生存之间，他必须做出艰难的选择。</p><p>影片剧本扎实，法庭戏份精彩绝伦，于和伟的表演更是入木三分。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20thriller%20movie%20poster%20with%20lawyer%20in%20courtroom%2C%20dramatic%20lighting%2C%20serious%20expression%2C%20dark%20atmosphere%2C%20cinematic%20style&width=600&height=800&seq=movie-thrill-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=empty%20courtroom%20with%20dramatic%20lighting%2C%20wooden%20benches%2C%20solemn%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=movie-thrill-bd-02&orientation=landscape',
    releaseDate: '2026-06-25',
    isNew: false,
    isHot: false,
    isFeatured: false,
    tags: ['悬疑', '法律', '剧情', '思考'],
  },
  {
    id: 'movie-14',
    title: '龙拳小子',
    englishTitle: 'Dragon Fist Kid',
    year: 2026,
    category: 'animation',
    subCategory: '动画',
    rating: 7.6,
    duration: '88分钟',
    region: '中国大陆',
    director: '田晓鹏',
    cast: ['刘昊然', '关晓彤', '陈飞宇', '欧阳娜娜'],
    description: '12岁的武术少年意外获得神龙之力的传承，从此开启了守护世界的冒险旅程。',
    content: '<p>《龙拳小子》是田晓鹏导演继《大圣归来》后的全新动画作品。故事主角小武是一个热爱武术的12岁少年，在一次偶然的机会中获得了远古神龙的力量传承。</p><p>从此他能够变身成为"龙拳战士"，拥有了超凡的武术能力。但随之而来的还有巨大的责任——他必须阻止黑暗势力收集七颗龙珠毁灭世界的阴谋。</p><p>影片武术动作设计流畅炫酷，3D画面精美绝伦，是一部老少皆宜的热血动画。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20young%20martial%20arts%20boy%20and%20dragon%2C%20dynamic%20pose%2C%20colorful%20energy%20effects%2C%20bright%20vibrant%20colors%2C%20anime%20style&width=600&height=800&seq=movie-anim-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Chinese%20temple%20on%20mountain%20with%20dragon%20flying%20in%20sky%2C%20golden%20light%2C%20epic%20landscape%2C%20animated%20movie%20style%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=movie-anim-bd-02&orientation=landscape',
    releaseDate: '2026-07-05',
    isNew: false,
    isHot: false,
    isFeatured: false,
    tags: ['动画', '热血', '武术', '奇幻'],
  },
  {
    id: 'movie-15',
    title: '赤道猎鹰',
    englishTitle: 'Equatorial Falcon',
    year: 2026,
    category: 'action',
    subCategory: '动作片',
    rating: 7.7,
    duration: '115分钟',
    region: '中国香港',
    director: '邱礼涛',
    cast: ['刘德华', '甄子丹', '吴镇宇', '谢霆锋'],
    description: '国际刑警组织追捕跨国军火集团的最新力作，横跨三大洲的刺激追逐战。',
    content: '<p>《赤道猎鹰》汇集了港片动作巨星，讲述国际刑警精英团队追捕一个跨国军火走私集团的故事。</p><p>刘德华饰演的刑警队长率领团队从香港出发，一路追踪到东南亚、中东和非洲，展开了一场跨越三大洲的惊险追逐。甄子丹饰演的神秘线人让整个行动充满了变数。</p><p>影片的动作场面包括直升机追逐、沙漠车战和高空跳伞，每一场都精心设计，拳拳到肉。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20action%20movie%20poster%20with%20police%20team%20in%20desert%2C%20weapons%2C%20helicopter%2C%20intense%20stare%2C%20warm%20desert%20tones%2C%20cinematic%20blockbuster%20style&width=600&height=800&seq=movie-action-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=desert%20landscape%20with%20convoy%20of%20vehicles%2C%20dust%20cloud%2C%20helicopter%20overhead%2C%20dramatic%20sunset%2C%20action%20cinematic%20wide%20shot&width=1600&height=900&seq=movie-action-bd-03&orientation=landscape',
    releaseDate: '2026-07-12',
    isNew: false,
    isHot: false,
    isFeatured: false,
    tags: ['动作', '警匪', '港产', '国际'],
  },
  {
    id: 'movie-16',
    title: '绿水青山',
    englishTitle: 'Green Mountains',
    year: 2026,
    category: 'documentary',
    subCategory: '纪录片',
    rating: 9.2,
    duration: '98分钟',
    region: '中国大陆',
    director: '陆川',
    cast: [],
    description: '历时三年拍摄的中国生态保护纪录片，展现大美中国的壮丽山河与珍稀野生动物的生存状态。',
    content: '<p>《绿水青山》是由陆川导演团队历时三年，横跨中国15个省份拍摄的生态保护题材纪录片。</p><p>影片以壮美的航拍镜头展现了中国从东北虎豹国家公园到海南热带雨林，从青藏高原到东海之滨的生态多样性。观众将看到野生大熊猫、雪豹、藏羚羊、中华白海豚等珍稀物种的真实生活状态。</p><p>影片还记录了一线生态保护工作者的感人故事，展现了"绿水青山就是金山银山"的生动实践。</p>',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20movie%20poster%20with%20beautiful%20mountain%20landscape%2C%20wild%20animals%2C%20panda%20in%20bamboo%20forest%2C%20green%20nature%2C%20cinematic%20realistic%20style&width=600&height=800&seq=movie-doc-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=stunning%20Chinese%20mountain%20landscape%20with%20mist%20and%20pine%20trees%2C%20golden%20sunrise%20light%2C%20pristine%20nature%2C%20documentary%20cinematic%20wide%20shot&width=1600&height=900&seq=movie-doc-bd-01&orientation=landscape',
    releaseDate: '2026-05-01',
    isNew: false,
    isHot: false,
    isFeatured: false,
    tags: ['纪录片', '自然', '生态', '中国'],
  },
];

export const featuredMovieIds = ['movie-1', 'movie-2', 'movie-3', 'movie-4', 'movie-8'];

export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);
export const featuredMovies = movies.filter(m => m.isFeatured);

export function getMovieById(id: string): Movie | undefined {
  return movies.find(m => m.id === id);
}

export function getMoviesByCategory(category: string): Movie[] {
  if (category === 'all') return movies;
  return movies.filter(m => m.category === category);
}

export function getRelatedMovies(currentId: string, category: string, limit: number = 4): Movie[] {
  return movies.filter(m => m.category === category && m.id !== currentId).slice(0, limit);
}